export default "__VITE_ASSET__BIFhXEMU__"